import { render, staticRenderFns } from "./SupportBusinessExcerpt.vue?vue&type=template&id=605dc5c8&scoped=true&"
import script from "./supportBusinessExcerpt.js?vue&type=script&lang=js&"
export * from "./supportBusinessExcerpt.js?vue&type=script&lang=js&"
import style0 from "./SupportBusinessExcerpt.vue?vue&type=style&index=0&id=605dc5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605dc5c8",
  null
  
)

export default component.exports